import React from 'react';
import ProfitabilityHub from '../Profitability/ProfitabilityHub';

const FinanceHub = () => {
  return (
    <div className="min-h-screen bg-[#0f1729]">
      <ProfitabilityHub />
    </div>
  );
};

export default FinanceHub;
